// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"a928f90c","271":"80e2970a","285":"ac8a99ab","318":"9c796736","357":"627ce7d2","553":"ad85f281","797":"71e02af8","859":"ebcb8824","993":"8c6e66cc"}[chunkId] + ".chunk.js";
};